import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicRule, RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { DynamicReviewsFormGroup } from '../../model';

@Component({
  selector: 'dynamic-reviews-form-display-conditions',
  templateUrl: './dynamic-reviews-form-display-conditions.component.html',
  styleUrls: ['./dynamic-reviews-form-display-conditions.component.scss'],
  standalone: false,
})
export class DynamicReviewsFormDisplayConditionsComponent {
  @Input() formGroup: FormGroup<DynamicReviewsFormGroup>;
  @Input() displayRules: DynamicRule[];
  @Input() displayRulesEntities: RuleEntity[];
}
